import React, { useState } from 'react'
import { Button, Dropdown, Menu } from 'antd'
import {
  CloudDownloadOutlined,
  EllipsisOutlined,
  RestOutlined
} from '@ant-design/icons'
import { useAppDispatch } from '../../../../app/hooks'
import { setExportListDrawerVisible } from '../../../../actions/photo'
import { trackClassifyClick } from '../../utils/trackClassify'

interface MoreActionsMenuProps {
  /** 「回收站」点击 · 不传则隐藏该菜单项（非管理员 / 无回收站入口的页面） */
  onOpenRecycleBin?: () => void
  /**
   * 「下载记录」点击的自定义处理 · 不传走默认行为（列表页埋点 + 打开导出抽屉）；
   * 详情页传入以走自己的埋点口径（trackDetailClick）
   */
  onOpenDownloadHistory?: () => void
  className?: string
}

const MoreActionsMenu: React.FC<MoreActionsMenuProps> = ({
  onOpenRecycleBin,
  onOpenDownloadHistory,
  className
}) => {
  const dispatch = useAppDispatch()

  const [visible, setVisible] = useState(false)

  const overlay = (
    <Menu>
      <Menu.Item
        key="download-history"
        onClick={() => {
          if (onOpenDownloadHistory) {
            onOpenDownloadHistory()
            return
          }
          trackClassifyClick('downloadRecord')
          dispatch(setExportListDrawerVisible(true))
        }}
      >
        <CloudDownloadOutlined style={{ marginRight: 6 }} />
        下载记录
      </Menu.Item>
      {onOpenRecycleBin && (
        <Menu.Item
          key="recycle-bin"
          onClick={() => {
            trackClassifyClick('recycleBin')
            onOpenRecycleBin()
          }}
        >
          <RestOutlined style={{ marginRight: 6 }} />
          回收站
        </Menu.Item>
      )}
    </Menu>
  )

  return (
    <Dropdown
      popupRender={() => overlay}
      trigger={['hover']}
      placement="bottomRight"
      mouseEnterDelay={0.05}
      mouseLeaveDelay={0.15}
      open={visible}
      onOpenChange={setVisible}
    >
      <Button
        className={className}
        icon={<EllipsisOutlined />}
        aria-label="更多"
        onClick={() => setVisible(true)}
      />
    </Dropdown>
  )
}

export default MoreActionsMenu
